import { Search, UserRound } from 'lucide-preact'
import { text } from '#contract'
import { useT } from '../../i18n/index.ts'
import { LockedInIcon } from '../icons/app-icons.tsx'
import { AppEmptyState } from './app-empty-state.tsx'
import styles from './apps.module.css'

/** LockedIn: a white bar with the profile and a search pill over an empty feed. */
export function LockedInApp() {
  const t = useT()
  return (
    <div class={styles.app}>
      <header class={[styles.header, styles.lockedin].join(' ')}>
        <span class={styles.avatar} aria-hidden="true">
          <UserRound />
        </span>
        <span class={styles.search}>
          <Search aria-hidden="true" />
          {t(text('os.app.lockedin.search'))}
        </span>
      </header>
      <AppEmptyState id="lockedin" icon={LockedInIcon} />
    </div>
  )
}
